export function CreateScene() {
  return (
    <v-btn
      prepend-icon="mdi-cube-send"
      color="primary">
      create scenes
    </v-btn>
  );
}

# Creating a Scene

To create a Scene, you first need an Asset, Template or Scene to create it from.

## Search

You can search for Assets, Templates or Scenes by typing in the relevant item name, only the items matching your search terms will be shown.

## <v-icon>mdi-file-image</v-icon> From Asset

You can create a new Scene or Scenes from 1 or more Assets. If you click multiple Assets, then multiple Scenes will be created.

## <v-icon>mdi-cube-scan</v-icon> With Template

You can create a new Scene or Scenes from 1 or more Templates. If you click multiple Templates, then multiple Scenes will be created.

## <v-icon>mdi-cube-outline</v-icon> Clone Scene

To clone a Scene, click the Scene you would like to Clone. You currently cannot clone more then 1 Scene at a time.

## Creating the Scene

To create a Scene click <CreateScene /> after selecting the item or items you with to create/clone it from.

## Cancelling

If you would like to cancel then click <v-icon>mdi-close-circle</v-icon> (top right).
